import { Link } from "react-router-dom";
import { useStore } from "../store/StoreContext";
import SEO from "../components/SEO";
import ProductCard from "../components/ProductCard";
import WordReveal from "../components/WordReveal";

export default function Wishlist() {
  const { wishlist, catalog } = useStore();
  const products = catalog.filter((p) => wishlist.includes(p.slug));

  return (
    <div className="mx-auto max-w-[1500px] px-4 sm:px-8 pt-8 sm:pt-12 pb-28" data-testid="wishlist-page">
      <SEO title="Wishlist — S H & SONS ®" description="Your saved S H & SONS ® export designs." />
      <div className="text-center">
        <p className="eyebrow mb-3">Saved pieces</p>
        <WordReveal as="h1" text="Wishlist" className="h-display text-6xl sm:text-7xl lg:text-[112px]" />
      </div>
      {products.length === 0 ? (
        <div className="py-24 text-center" data-testid="wishlist-empty">
          <p className="text-2xl font-light text-charcoal">No saved pieces yet</p>
          <p className="mt-3 text-[13px] text-mocha">Tap the heart on any product to keep it here.</p>
          <Link to="/shop" data-testid="wishlist-shop-link" className="pill-dark mt-8 px-8">Browse the Collection</Link>
        </div>
      ) : (
        <div className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-14">
          {products.map((p, i) => (
            <ProductCard key={p.slug} product={p} index={i} />
          ))}
        </div>
      )}
    </div>
  );
}
